/**
 * Count how many times a source has been inserted into document HTML
 * via data-wf-citation-id markers.
 */
export function countCitationIdInDocument(html, citationId) {
	if (!html || !citationId) return 0;
	const esc = String(citationId).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	const re = new RegExp(`data-wf-citation-id=["']${esc}["']`, 'g');
	const m = html.match(re);
	return m ? m.length : 0;
}

/**
 * Wrap visible citation HTML so occurrences can be counted for APA first/subsequent group-author logic.
 */
/**
 * @param {string} innerHtml
 * @param {string} citationId
 * @param {Record<string, unknown> | null} insertMeta - optional serialized insert context for re-sync after citation edit
 */
export function wrapCitationInsertHtml(innerHtml, citationId, insertMeta = null) {
	if (!citationId) return innerHtml;
	const id = String(citationId).replace(/"/g, '&quot;');
	let metaAttr = '';
	if (insertMeta && typeof insertMeta === 'object') {
		try {
			const enc = encodeURIComponent(JSON.stringify(insertMeta));
			metaAttr = ` data-wf-cite-meta="${enc}"`;
		} catch {
			metaAttr = '';
		}
	}
	// Block quotes use <p>+<blockquote>; wrapping those in <span> is invalid and TinyMCE may unwrap.
	const usesBlockMarkup = /<(?:p|blockquote|div|h[1-6]|ul|ol|table)\b/i.test(innerHtml || '');
	const tag = usesBlockMarkup ? 'div' : 'span';
	return `<${tag} data-wf-citation-id="${id}" class="wf-citation-insert"${metaAttr}>${innerHtml}</${tag}>`;
}
